import { useEffect, useState } from 'react';

import { useATFMetricsPage } from '@common/metrics';
import { ProductOptionScreen } from '@widgets/product-option';
import {
  ErrorBoundaryWrapper,
  getSelectionOptionStorageKey,
  PRODUCT_OPTION_TEST_ON,
  useCatalogProductIdParams,
  useIsAuthenticated,
  usePdpBaseInfo,
} from '@domains/pdp-common';
import {
  BadgeContainer,
  BottomFloatingContainer,
  FloatingPromotionBannerContainer,
  FloatingZigzinBannerContainer,
  GalleryContainer,
  ProductMetadataContainer,
  ProductNameContainer,
  ProductShareContainer,
  ProductSizeInfoIconContainer,
  ProductSwatchCarouselContainer,
  RatingsContainer,
  ShopLinkContainer,
  SpecialTimeContainer,
} from '@domains/pdp-features';

import { SelectOptionsScreen } from './SelectOptionsScreen';

export const TTI_NAVIGATION = 'product_detail';

export function LegacyATFScreen({ featureList = [] }: { featureList: string[] }) {
  const isProductOptionTestOn = featureList.includes(PRODUCT_OPTION_TEST_ON);
  const param = useCatalogProductIdParams();
  const { product } = usePdpBaseInfo(param);
  const [is_select_option_opened, setIsSelectOptionOpened] = useState(false);
  const { isLoggedIn } = useIsAuthenticated();
  const handleSelectOptionOpened = () => {
    setIsSelectOptionOpened((prev) => !prev);
  };

  useATFMetricsPage({
    payload: {
      navigation: TTI_NAVIGATION,
    },
    options: {
      tags: ['img'],
    },
  });

  useEffect(() => {
    const is_option_opened = sessionStorage.getItem(getSelectionOptionStorageKey(product.id));

    if (is_option_opened) {
      setIsSelectOptionOpened(is_option_opened === 'opened');
      sessionStorage.removeItem(getSelectionOptionStorageKey(product.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className='pdp__image'>
        <ErrorBoundaryWrapper>
          <GalleryContainer />
        </ErrorBoundaryWrapper>

        <ErrorBoundaryWrapper>
          <SpecialTimeContainer />
        </ErrorBoundaryWrapper>
      </div>

      <div className='pdp_shop_info_row'>
        <ErrorBoundaryWrapper>
          <ShopLinkContainer />
        </ErrorBoundaryWrapper>

        <div style={{ display: 'flex' }}>
          <ErrorBoundaryWrapper>
            <ProductShareContainer />
          </ErrorBoundaryWrapper>

          <ErrorBoundaryWrapper>
            <ProductSizeInfoIconContainer />
          </ErrorBoundaryWrapper>
        </div>
      </div>

      <ErrorBoundaryWrapper>
        <BadgeContainer />
      </ErrorBoundaryWrapper>

      <ErrorBoundaryWrapper>
        <ProductNameContainer className='pdp__title' />
      </ErrorBoundaryWrapper>

      <ErrorBoundaryWrapper>
        <RatingsContainer />
      </ErrorBoundaryWrapper>

      <ErrorBoundaryWrapper>
        <ProductSwatchCarouselContainer />
      </ErrorBoundaryWrapper>

      <ErrorBoundaryWrapper>
        <ProductMetadataContainer />
      </ErrorBoundaryWrapper>

      <ErrorBoundaryWrapper>
        <div className='pdp__bottomFloating'>
          <BottomFloatingContainer onClick={handleSelectOptionOpened}>
            <FloatingPromotionBannerContainer />
            <FloatingZigzinBannerContainer is_app is_logged_in={isLoggedIn} />
          </BottomFloatingContainer>
        </div>
      </ErrorBoundaryWrapper>

      <ErrorBoundaryWrapper>
        {isProductOptionTestOn ? (
          <ProductOptionScreen
            open={is_select_option_opened}
            onClose={handleSelectOptionOpened}
            context={{
              is_zigzag_app: true,
              is_logged_in: isLoggedIn,
            }}
          />
        ) : (
          <SelectOptionsScreen open={is_select_option_opened} onClose={handleSelectOptionOpened} />
        )}
      </ErrorBoundaryWrapper>
    </>
  );
}
